module.exports = __webpack_public_path__ + "static/img/d-4.1b762ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-4.png
// module id = XYqs
// module chunks = 0